// kits/LayoutKit/ProjectCard.jsx

import React from "react";
import { Link } from "react-router-dom";
import MonoButton from "../../components/MonoButton";
import { PaperBG } from "../DesignKit";
import { FaPalette, FaFolderOpen, FaBatteryFull } from "react-icons/fa";


const iconMap = {
  palette: <FaPalette className="text-xl" />,
  folder: <FaFolderOpen className="text-xl" />,
  battery: <FaBatteryFull className="text-xl" />,
};

const ProjectCard = ({ title, description, icon, href, bg, titleClassName = "" }) => {
  return (
    <PaperBG>
    <div className="border border-gray-900 rounded-lg p-4 ${bg} bg-gray-50 font-mono flex flex-col h-full space-y-4 shadow-sm hover:shadow-md transition-shadow ">
      {/* Icon oben */}
    {icon && <div className="text-sm">{iconMap[icon]}</div>}

      {/* Titel */}
     <h3 className={`text-lg font-semibold ${titleClassName || ""}`}>
  {title}
</h3>

      {/* Beschreibung */}
      <p className="text-sm text-gray-600 flex-grow">{description}</p>

      {/* Link */}
      {href && (
        <MonoButton className="text-xs">
        <Link
          to={href}
          className=" hover:text-orange-50"
        >
          Mehr erfahren
        </Link>
        </MonoButton>
      )}
    </div>
    </PaperBG>
  );
};

export default ProjectCard;
